/**
 * Type d'établissement : ce que l'écran propose, ce que la base accepte.
 *
 * ⚠️ Le formulaire « Nouveau marchand » envoyait `supermarche` (français, sans
 * accent), alors que l'enum Postgres `merchant_kind` (migration 0001) ne connaît
 * que `restaurant` et `supermarket`. Choisir « Supermarché » faisait échouer la
 * création avec `invalid input value for enum merchant_kind` — l'intention du
 * dispatch était claire, seule la valeur était fausse.
 *
 * Le test `typeMarchand.test.ts` relit la migration pour garder les deux côtés
 * alignés : renommer la valeur de l'enum sans toucher ici ferait échouer le test.
 */

export type KindMarchand = 'restaurant' | 'supermarket'

/** Les choix du formulaire : `valeur` EST la valeur de l'enum, sans traduction. */
export const TYPES_MARCHAND: ReadonlyArray<{ valeur: KindMarchand; libelle: string }> = [
  { valeur: 'restaurant', libelle: 'Restaurant' },
  { valeur: 'supermarket', libelle: 'Supermarché' },
]

const SYNONYMES: Record<string, KindMarchand> = {
  restaurant: 'restaurant',
  supermarket: 'supermarket',
  // Anciennes valeurs de l'interface, par prudence (sessions ouvertes, scripts).
  supermarche: 'supermarket',
  supermarché: 'supermarket',
}

/** Valeur de formulaire → valeur d'enum. Lève sur une valeur inconnue plutôt que d'envoyer n'importe quoi. */
export function kindDepuisSaisie(saisie: string): KindMarchand {
  const k = SYNONYMES[String(saisie).trim().toLowerCase()]
  if (!k) throw new Error(`Type d'établissement inconnu : « ${saisie} ».`)
  return k
}
